var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnTestParser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4H5V6H19V4ZM15 8H5V10H15V8ZM19.7071 11.7071L12.2071 19.2071L11.5614 19.8528L10.8598 19.2682L7.85982 16.7682L9.14018 15.2318L11.4386 17.1472L18.2929 10.2929L19.7071 11.7071ZM9 12H5V14H9V12Z",
    fill: "#B6B8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTestParser);
export default __webpack_public_path__ + "static/media/icn-test-parser.f9e8a2067f52854b6bf8357b60148293.svg";
export { ForwardRef as ReactComponent };